import type { NDateLocale } from './enUS'
import { enUS } from 'date-fns/locale'

const dateLoLA: NDateLocale = {
  name: 'lo-LA',
  locale: enUS
}

export default dateLoLA
